"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconCostEfficient = function IconCostEfficient(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M20 9.83a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0m7 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M6.711 15.245a2.07 2.07 0 0 1 3.018 0l2.53 2.695.261-.15a11.6 11.6 0 0 1 5.188-1.452l.392-.008h10.643c6.762.018 12.239 5.495 12.257 12.26v.618a2.85 2.85 0 0 0 1.984-2.316l.02-.174 1.993.164A4.85 4.85 0 0 1 41 31.262a12.18 12.18 0 0 1-6.776 10.814l-.224.108v2.286l-.01.136c-.145 1.058-1.096 1.815-2.07 1.724l-2.77-.003a2 2 0 0 1-2.14-1.72l-.01-.11-.034-1.256-5.966.076v1.153l-.008.122a2 2 0 0 1-2.176 1.747H16.15l-.068.006a2 2 0 0 1-2.047-1.586l-.025-.146L14 44.48v-1.981l-.192-.072a12.18 12.18 0 0 1-7.3-7.999l-.036-.128H3v-9l3.555-.001.012-.04c.319-1.087.779-2.127 1.369-3.094l.014-.024-3.888-4.114zm1.56 1.37a.07.07 0 0 0-.051-.023q-.03-.001-.056.028l-1.346 1.413 3.69 3.904-.47.669a10.9 10.9 0 0 0-1.732 3.912l-.175.782L5 27.299v5h3.077l.163.802a10.18 10.18 0 0 0 7.048 7.721l.712.214v3.31l.11-.006h2.77l.12.008v-3.005l9.913-.125.083 3.114H32v-3.477l.626-.252A10.18 10.18 0 0 0 39 31.08v-2.487C38.985 22.93 34.4 18.345 28.74 18.33H18.104a9.57 9.57 0 0 0-5.432 1.72l-.709.495zM29 23.33v-1H19v1zm-14 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
    clipRule: "evenodd"
  })));
};

export { IconCostEfficient, IconCostEfficient as default };
